import { ProductVatConfigManagement } from '@/pages/product-vat-config/ProductVatConfigManagement';
import { businessEntityVatConfigScreen } from '@/pages/product-vat-config/productVatConfigScreenConfig';

const BusinessEntityVatConfigManagement = () => {
  return (
    <ProductVatConfigManagement
      screenConfig={businessEntityVatConfigScreen}
    />
  );
};

export default BusinessEntityVatConfigManagement;
